<template>
  <div>
    <Card>
        <Row>
        <i-col>
          <i-form ref="formItemOwn" :model="formItemOwn" :label-width="100">
          <FormItem  label="数据对象模型" prop="contentType">
             <Select  v-model="formItemOwn.contentType" style="width:93%;" @on-change="handleTypeChange" filterable>
              <Option  v-for="item in no_select_content_type" :value="item.key" :key="item.id" :label="item.label"></Option>
             </Select>
          </FormItem>
            <form-item label="关联数据对象" prop="search">
               <i-input v-model="formItemOwn.search" placeholder="请输入对象ID" style="width: 760px"></i-input>
            </form-item>
            <form-item label="关联权限" prop="permissions">
                <transfer
                :data="no_select_permission"
                :target-keys="formItemOwn.dataPermissions"
                :list-style="listStyle"
                :titles="['未分配权限', '已分配权限']"
                @on-change="permissionChange"
                filterable></transfer>
            </form-item>
            <form-item label="已授权的对象">
              <tables border search-place="bottom" v-model="tableData" :columns="columns" :height="200" :width="760"/>
              <div style="margin: 10px 0; overflow: hidden;">
                <div style="float: right;">
                  <page :total="count" :current="page" :page-size="size" @on-change="getObjectPermList"></page>
                </div>
              </div>
            </form-item>
            <form-item>
                <i-button type="primary" @click="handleSubmit('formItemOwn')">提交</i-button>
                <i-button style="margin-left: 8px">取消</i-button>
            </form-item>
            </i-form>
            <spin fix v-if="changeLoadingShow">
            <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
            <div>请求中</div>
            </spin>
        </i-col>
       </Row>
    </Card>
  </div>
</template>
<script>
import { getAllPermission, getAllContentType, getObjectPermList, deleteDataPerm } from '@/api/user'
import { opscenterRoleData } from '@/api/opscenter'
import Tables from '_c/tables'
export default {
  name: 'DataPerm',
  props:
  {
    'formItem': Object,
    'handleChangePermissions': {
      type: Function
    }
  },
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      columns: [
        { title: '对象ID', key: 'object_pk', align: 'center' },
        { title: '对象模型', key: 'content_type', align: 'center' },
        { title: '权限', key: 'permission', align: 'center' },
        // { title: '关联角色', key: 'role', align: 'center' },
        {
          title: '操作',
          width: 250,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                on: {
                  'on-ok': () => {
                    this.handleDelete(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      no_select_permission: [],
      no_select_content_type: [],
      formItemOwn: {
        roleId: this.formItem['id'],
        contentType: '',
        search: '',
        dataPermissions: []
      },
      listStyle: {
        width: '350px',
        height: '350px'
      }
    }
  },
  watch: {
    formItem () {
      this.formItemOwn['roleId'] = this.formItem['id']
      this.getObjectPermList()
    },
    deep: true
  },
  methods: {
    handleDelete (params) {
      deleteDataPerm(params.row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getObjectPermList()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getObjectPermList (value = 1) {
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page,
        'roleId': this.formItemOwn['roleId']
      }
      getObjectPermList(params).then(res => {
        this.tableData = res.data
        this.count = res.data.count
      })
    },
    handleTypeChange (value) {
      this.getNoSelectPermission(value)
    },
    getNoSelectPermission (value) {
      let that = this
      that.no_select_permission = []
      getAllPermission().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i].content_type === value) {
              that.no_select_permission.push({
                key: result[i].id,
                label: result[i].name
              })
            }
          }
        }
      })
    },
    getNoSelectContentType () {
      let that = this
      that.no_select_content_type = []
      getAllContentType().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_content_type.push({
              key: result[i].id,
              label: result[i].name + result[i].app_label + '-' + result[i].model
            })
          }
        }
      })
    },
    permissionChange (newTargetKeys) {
      this.formItemOwn.dataPermissions = newTargetKeys
    },
    handleSubmit (name) {
      let that = this.formItemOwn
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          opscenterRoleData(this.formItemOwn).then(res => {
            if (res.status === 200) {
              this.$Notice.success({ title: '操作成功！' })
              that.roleId = 0
              that.contentType = ''
              that.search = ''
              that.dataPermissions = []
              this.handleChangePermissions(false)
            } else {
              this.$Notice.error({title: res.data.data})
            }
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.getNoSelectContentType()
  }
}
</script>
